/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AddUserToCourseRequestAccessibleModuleIds } from './addUserToCourseRequestAccessibleModuleIds';
import type { AddUserToCourseRequestExtraModuleIds } from './addUserToCourseRequestExtraModuleIds';

/**
 * Request model for adding a user to a course
 */
export interface AddUserToCourseRequest {
  accessibleModuleIds?: AddUserToCourseRequestAccessibleModuleIds;
  extraModuleIds?: AddUserToCourseRequestExtraModuleIds;
}
